import http from '../../../service/axios';
import { IUserUpdate } from '../types/User';
import { PushSettings } from '../../settings/types/PushSettings';

export const userAPI = {
  getProfile: async () => await http.get('/user/me'),
  update: async (body: IUserUpdate) =>
    await http.post('/user/save-settings', body),
  // Настройки уведомлений: тот же путь, но JSON-телом.
  //
  // В документации этот вызов описан как PUT, и из curl он так и работает.
  // Из браузера — нет: на преflight сервер отвечает
  // `Access-Control-Allow-Methods: GET, POST, OPTIONS`, PUT в списке нет, и
  // Chrome блокирует запрос до отправки. Снаружи это выглядит как «настройка
  // не сохраняется», потому что до сервера ничего не доезжает. POST на этот
  // же путь принимается и сохраняет те же поля — проверено на /user/me.
  //
  // Content-Type задаём явно: интерцептор в service/axios проставляет
  // multipart/form-data всем запросам, у которых его нет.
  // Смена языка: язык — заголовком Language (его бэкенд и читает), имя —
  // телом, иначе save-settings запрос не принимает.
  saveLanguage: async (name: string, language: string) =>
    await http.post('/user/save-settings', { name }, {
      headers: { Language: language },
    }),
  savePushSettings: async (body: PushSettings) =>
    await http.post('/user/save-settings', body, {
      headers: { 'Content-Type': 'application/json' },
    }),
};
